import { ArcPresenceState } from '../../helpers/arcPresence/arcPresenceStore'
import styles from './ArcPresence.module.scss'

const CLASS_FOR_STATE: Record<ArcPresenceState, string | undefined> = {
  [ArcPresenceState.Working]: styles.arcWorking,
  [ArcPresenceState.Done]: styles.arcDone,
  [ArcPresenceState.NeedsApproval]: styles.arcApproval,
  [ArcPresenceState.Failed]: undefined,
}

/** The class a row takes while Arc works on its record, or just after. */
export const arcTouchClass = (state: ArcPresenceState | null): string | undefined =>
  state ? CLASS_FOR_STATE[state] : undefined
